/** True when a caller supplied the canonical 32-byte digest representation. */
export function isAsyncCryptoDigest(digest) {
    return digest.length === 32 &&
        digest.every(byte => Number.isInteger(byte) && byte >= 0 && byte <= 0xff);
}
/**
 * Reject malformed output from an optional cryptography backend before it can
 * be interpreted as key or signature material.
 */
export function validateAsyncCryptoBytes(operation, value, expectedLength) {
    if (!(value instanceof Uint8Array)) {
        throw new TypeError(`${operation} returned a non-byte result`);
    }
    if (expectedLength !== undefined && value.length !== expectedLength) {
        throw new Error(`${operation} returned ${value.length} bytes; expected ${expectedLength}`);
    }
    return value;
}
function backendGlobal() {
    return globalThis;
}
/** Installs an optional process/page-wide backend for opportunistic SDK use. */
export function registerAsyncCryptoBackend(backend) {
    backendGlobal().__bsvSdkAsyncCryptoBackendV1 = backend;
}
/** Removes `backend` if it is still the active optional implementation. */
export function unregisterAsyncCryptoBackend(backend) {
    const registry = backendGlobal();
    if (registry.__bsvSdkAsyncCryptoBackendV1 === backend) {
        delete registry.__bsvSdkAsyncCryptoBackendV1;
    }
}
/**
 * Returns a warm backend supporting `operation`. A cold backend is prepared in
 * the background while the current call retains the existing JavaScript path.
 */
export function readyAsyncCryptoBackend(operation) {
    const backend = backendGlobal().__bsvSdkAsyncCryptoBackendV1;
    if (backend === undefined)
        return undefined;
    if (!backend.isReady()) {
        void backend.preload().catch(() => { });
        return undefined;
    }
    return backend.supportsCrypto(operation) ? backend : undefined;
}
//# sourceMappingURL=AsyncCryptoBackend.js.map